export function generateCSV({ date, fullDate, groups, getAttendance }) {
  // Headers
  const headers = ['Group', 'Camper Name', 'Status', 'Arrival Time', 'Dismissal Time', 'Notes'];
  
  // Build rows
  const rows = [];
  
  // Sort groups
  const groupNames = Object.keys(groups).sort((a, b) => {
    if (a === 'Unassigned') return 1;
    if (b === 'Unassigned') return -1;
    return a.localeCompare(b);
  });

  groupNames.forEach(groupName => {
    const campers = groups[groupName];
    
    campers.forEach(camper => {
      const attendance = getAttendance(camper.id, date);
      const firstName = camper.firstName || 'Unknown';
      const lastName = camper.lastName || '';
      
      let status = 'NOT SELECTED';
      if (attendance.status === 'not_selected') {
        status = 'NOT SELECTED';
      } else if (attendance.status === 'absent') {
        status = 'Absent';
      } else if (attendance.lateTime && attendance.earlyTime) {
        status = 'Late/Leaving Early';
      } else if (attendance.lateTime) {
        status = 'Late';
      } else if (attendance.earlyTime) {
        status = 'Leaving Early';
      } else {
        status = 'Present';
      }
      
      rows.push([
        groupName,
        `${firstName} ${lastName}`,
        status,
        attendance.lateTime || '',
        attendance.earlyTime || '',
        '' // Notes placeholder - could be added if needed
      ]);
    });
  });

  // Convert to CSV string
  const escapeCSV = (value) => {
    if (value === null || value === undefined) return '';
    const stringValue = String(value);
    if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  };

  const csvContent = [
    `Holiday Camp Attendance - ${fullDate}`,
    '',
    headers.map(escapeCSV).join(','),
    ...rows.map(row => row.map(escapeCSV).join(','))
  ].join('\n');

  // Create and download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `RRDC_Attendance_${date}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
